import { PriceDisplay, typographyV2 } from '@toggle/design-system';
import { PriceStatus } from '@toggle/helpers';
import styled, { css } from 'styled-components';

export const DateSpan = styled.span`
  ${typographyV2.bodyXs}
  color: var(--text-soft);
`;

export const ProportionChangeContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const ProportionChangeColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

export const ProportionPrice = styled.span`
  font-family: var(--font-roboto-mono);
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: var(--text-default);
`;

export const ProportionCurrency = styled.span`
  ${typographyV2.bodyXXs}
  color: var(--text-default);
  text-transform: uppercase;
`;

const percentageChangeColors = {
  [PriceStatus.Default]: 'var(--text-soft)',
  [PriceStatus.Negative]: 'var(--viz-bearish)',
  [PriceStatus.Positive]: 'var(--viz-bullish)',
};

export const PercentageChange = styled.span<{ $status: PriceStatus }>`
  font-family: var(--font-roboto-mono);
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: ${({ $status }) => percentageChangeColors[$status]};
`;

export const StyledPriceDisplay = styled(PriceDisplay)<{
  $isHorizontalView?: boolean;
  $showPricePercentage?: boolean;
  $showDotSeparator?: boolean;
}>`
  ${PriceDisplay.Styled.Price} {
    ${({ $isHorizontalView }) =>
      $isHorizontalView ? typographyV2.bodySm : typographyV2.titleLg}
  }

  ${PriceDisplay.Styled.OutsideHoursTag} {
    margin-right: ${({ $isHorizontalView }) =>
      $isHorizontalView ? 0 : '12px'};
  }

  ${PriceDisplay.Styled.Currency} {
    ${typographyV2.bodyXXs};
  }

  ${PriceDisplay.Styled.PercentageChangeLabel} {
    ${({ $showPricePercentage }) =>
      !$showPricePercentage &&
      css`
        display: none;
      `}
  }

  ${({ $isHorizontalView }) =>
    $isHorizontalView &&
    css`
      && {
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 8px;
      }
    `}

  ${({ $showDotSeparator, $isHorizontalView }) =>
    $showDotSeparator &&
    $isHorizontalView &&
    css`
      ${PriceDisplay.Styled.LabelsContainer}::before {
        content: '';
        width: 2px;
        height: 2px;
        border-radius: 50%;
        background-color: var(--icon-soft);
        display: flex;
        align-self: center;
        margin-right: 8px;
      }
    `}
`;
